<template>
  <div class="step finish step--finish step-end">
    <div class="finish__title text-shadow" v-html="$t('endTerraform.title')"></div>

    <div class="finish__text" v-html="$t('endTerraform.title2')"></div>

    <Button :class="'finish__button'" @click="next" v-html="$t('endTerraform.button')"></Button>
  </div>
</template>

<script>

import { mapState } from 'vuex'
import Button from '@/components/global/Button'

export default {
  name: 'StepEndTerraform',
  props: {},

  components: {
    Button,
  },

  data () {
    return {}
  },

  mounted () {
    if (this.$gtm) {
      this.$gtm.trackEvent({
        'event': 'Event',
        'analytics_action': this.$store.state.step + '-mounted',
        'analytics_label': this.$store.state.step,
      })
    }
  },

  created () {},

  updated () {},

  methods: {
    next () {
      if (this.$gtm) {
        this.$gtm.trackEvent({
          'event': 'Event',
          'analytics_action': this.$store.state.step + '-button-to-products',
          'analytics_label': this.$store.state.step,
        })
      }

      this.$emit('next')
    },
  },

  watch: {},

  computed: {
    ...mapState({
      step: state => state.step,
    }),
  },
}
</script>

<style lang="scss" scoped>

</style>
